import React, { useState } from "react";
import Card from "../Common/Card";
import "moment-timezone";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import TextInputWithIcon from "../Common/TextInputWithIcon";
import { ClipLoader } from "react-spinners";
import Payment from "services/Payment";
import { toast } from "react-toastify";

export default function LeaveDetailsCard({ collection, getLeaveDetails }) {
	const dateFormat = useSelector((state) => state.date.format);
	const [review, setReview] = useState("");
	const [rejectLoader, setRejectLoader] = useState(false);
	const [acceptLoader, setAcceptLoader] = useState(false);

	const leaveHandler = async (status) => {
		if (status === "Rejected") {
			setRejectLoader(true);
		} else {
			setAcceptLoader(true);
		}
		let payload = {
			review: review,
			status: status,
		};
		let response = await Payment.leaveConfirmation(collection?.id, payload);
		if (response.success) {
			setRejectLoader(false);
			setAcceptLoader(false);
			getLeaveDetails();
			if (response.results.status === "Rejected") {
				toast.error("Leave Request Rejected");
			} else {
				toast.success("Leave Request Approved");
			}
		}
	};

	return (
		<div className='px-2 pb-5'>
			<Card title={`Leave Details`}>
				<div>
					<table className='table-fixed w-full paymentSettlementLabel'>
						<tbody className="before:content-[' '] before:block before:h-2 border-b-2">
							<tr>
								<td className='text-000080 text-12 font-medium py-[6px]'>
									Name
								</td>
								<td className='text-000080 text-12 font-medium py-[6px] text-right'>
									{collection?.emp_name}
								</td>
							</tr>
							<tr>
								<td className='text-000080 text-12 font-medium py-[6px]'>
									Start Date
								</td>
								<td className='text-000080 text-12 font-medium py-[6px] text-right'>
									{moment(collection?.start_date).format(dateFormat)}
								</td>
							</tr>
							<tr>
								<td className='text-000080 text-12 font-medium py-[6px]'>
									End Date
								</td>
								<td className='text-000080 text-12 font-medium py-[6px] text-right'>
									{moment(collection?.end_date).format(dateFormat)}
								</td>
							</tr>
							<tr>
								<td className='text-000080 text-12 font-medium py-[6px]'>
									Status
								</td>
								<td
									className={`text-12 font-medium py-[6px] text-right ${
										collection?.status == "Approved"
											? "text-success"
											: collection?.status == "Rejected"
											? "text-primary"
											: "text-orange-400"
									}`}>
									{collection?.status}
								</td>
							</tr>

							<tr>
								<td className='text-000080 text-12 font-medium py-[6px]'>
									Duration
								</td>
								<td className='text-000080 text-12 font-medium py-[6px] text-right'>
									{collection?.duration}
								</td>
							</tr>
							<tr>
								<td className='text-000080 text-12 font-medium py-[6px]'>
									Description
								</td>
								<td className='text-000080 text-12 font-medium py-[6px] text-right'>
									{collection?.purpose_of_leave}
								</td>
							</tr>
							<tr>
								<td className='text-000080 text-12 font-medium py-[6px]'>
									Review
								</td>
								<td className='text-000080 text-12 font-medium py-[6px] text-right'>
									{collection?.review}
								</td>
							</tr>
						</tbody>
					</table>
					{collection?.status === "Pending" && (
						<>
							<div className='text-left'>
								<TextInputWithIcon
									type='text'
									inputText={review}
									setInputText={setReview}
									placeholder={`Enter review`}
								/>
							</div>
							<div className='flex'>
								<button
									className=' font-bold h-10 bg-primary rounded-[7px] w-1/2 mr-2 text-white  border-solid'
									onClick={() =>
										!rejectLoader && leaveHandler("Rejected")
									}>
									{rejectLoader ? (
										<ClipLoader
											sizeUnit={"px"}
											size={20}
											color={"white"}
											loading={true}
										/>
									) : (
										`Reject`
									)}
								</button>
								<button
									className='font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white'
									onClick={() =>
										!acceptLoader && leaveHandler("Approved")
									}>
									{acceptLoader ? (
										<ClipLoader
											sizeUnit={"px"}
											size={20}
											color={"white"}
											loading={true}
										/>
									) : (
										`Accept`
									)}
								</button>
							</div>
						</>
					)}
				</div>
			</Card>
		</div>
	);
}
